export type ImportEncoding = 'auto' | 'utf-8' | 'utf-16le' | 'utf-16be' | 'windows-1252';
export const importEncodings: { value: ImportEncoding; label: string }[] = [
  { value: 'auto', label: 'Automatic (UTF-8 or Unicode BOM)' },
  { value: 'utf-8', label: 'UTF-8' },
  { value: 'utf-16le', label: 'UTF-16 little endian' },
  { value: 'utf-16be', label: 'UTF-16 big endian' },
  { value: 'windows-1252', label: 'Windows-1252 (Western European)' },
];

/** Strict decoding prevents silently replacing identifier bytes. Original bytes stay with the upload. */
export function decodeImportSource(bytes: Uint8Array, requested: ImportEncoding = 'auto'): { text: string; encoding: Exclude<ImportEncoding, 'auto'> } {
  if (bytes.byteLength > 5 * 1024 * 1024) throw new Error('Choose a file no larger than 5 MiB.');
  const bom = bytes[0] === 0xef && bytes[1] === 0xbb && bytes[2] === 0xbf ? 'utf-8'
    : bytes[0] === 0xff && bytes[1] === 0xfe ? 'utf-16le'
      : bytes[0] === 0xfe && bytes[1] === 0xff ? 'utf-16be' : undefined;
  const encoding = requested === 'auto' ? bom ?? 'utf-8' : requested;
  if (bom && requested !== 'auto' && bom !== requested) throw new Error(`The file has a ${bom.toUpperCase()} byte-order mark. Select Automatic or ${bom.toUpperCase()}.`);
  let text: string;
  try { text = new TextDecoder(encoding, { fatal: true }).decode(bytes); }
  catch { throw new Error(`This file cannot be decoded as ${encoding.toUpperCase()}. Choose its original encoding and try again. No replacement characters were inserted.`); }
  if (text.includes('\0')) throw new Error('The decoded source contains NUL characters. Choose the original encoding (often UTF-16 for this file), or remove NUL characters before inspection.');
  return { text, encoding };
}
